module.exports = __webpack_public_path__ + "img/bm.8c2f9de1.svg";